<!-- ロゴ -->
<template>
  <div class="crly-a-common-logo" @click="clickLogo">
    <CMS
      contents_type="block_contents"
      location_code="CRLY_TOP_01_001-top_logo"
    />
  </div>
</template>

<script>
export default {
  name: "CrlyAtomsCommonHeaderLogo",
  methods: {
    clickLogo() {
      this.$emit("clickMenuBtn", false);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/atoms/common/logo.scss";
</style>
